import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import './SidebarItem.css';
import { Tooltip } from '@mui/material';

function SidebarItem(props) {
  const { path, icon, label, isOpen, disableNavigation = false } = props;
  const active = useLocation().pathname == path;
  const [isHovered, setIsHovered] = useState(false);

  const handleMouseEnter = () => {
    if (!active) {
      setIsHovered(true);
    }
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  const itemContent = (
    <>
      <div className={active ? "sidebar-item-icon-actived" : disableNavigation ? "sidebar-item-icon-disabled" : "sidebar-item-icon"}>
        {icon}
      </div>
      {isOpen && (
        <span className={
          active
            ? "sidebar-label-active"
            : disableNavigation
              ? "sidebar-label-disabled"
              : isHovered
                ? "sidebar-label-hover"
                : "sidebar-label"
        }>
          {label}
        </span>
      )}
    </>
  );

  // Se a navegação estiver desabilitada, renderiza um div em vez de um NavLink
  if (disableNavigation) {
    return (
      <div
        style={{ textDecoration: 'none', cursor: 'not-allowed', pointerEvents: 'none' }}
        className={active ? "sidebar-item-actived sidebar-item-disabled" : "sidebar-item sidebar-item-disabled"}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        aria-disabled="true"
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          return false;
        }}
      >
        {isOpen ? (
          itemContent
        ) : (
          <Tooltip title={label} placement="right">
            <div className="sidebar-item-content">
              {icon && <div className="sidebar-item-icon-disabled">
                {icon}
              </div>}
            </div>
          </Tooltip>
        )}
      </div>
    );
  }

  return (
    <NavLink
      to={path}
      style={{ textDecoration: 'none' }}
      className={active ? "sidebar-item-actived" : "sidebar-item"}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {isOpen ? (
        itemContent
      ) : (
        <Tooltip title={label} placement="right">
          <div className="sidebar-item-content">
            {icon && <div className={active ? "sidebar-item-icon-actived" : "sidebar-item-icon"}>
              {icon}
            </div>}
          </div>
        </Tooltip>
      )}
    </NavLink>
  );
}

export default SidebarItem;